// @flow
import React from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';
import { MessageList, messageListTypes } from 'bk-web-app/message-list';
import { SidebarSection } from 'bench-internal-theme';

import { type ClientComment } from './types';

const CommentCardWrapper = styled.div`
  padding-bottom: 8px;
`;

type ClientCommentsProps = {
  clientComments: Array<ClientComment>,
  createMessage: (body: string) => Promise<any>,
  journalEntryId: string,
};

const ClientComments = ({ clientComments, createMessage, journalEntryId }: ClientCommentsProps) => (
  <SidebarSection background={colors.shell} title="Client Comments">
    <CommentCardWrapper>
      {/* MessageList is used here because the user is only allowed to create new messages */}
      <MessageList
        createMessage={createMessage}
        listType={messageListTypes.JOURNAL_ENTRY_CLIENT_COMMENT}
        messages={clientComments}
        parentId={journalEntryId}
        placeholder="Leave a comment for your client"
        zeroStateMessage="(Currently no client comments for journal entry.)"
      />
    </CommentCardWrapper>
  </SidebarSection>
);

export default ClientComments;
